<div #map class="w-full" [style.height]="height + 'px'"></div>
